<template>
  <div class="rules">
    <div class="rules-content">
      <div class="rules-container">
      <p>{{ $t('index.rules[0]') }}</p>
      <p>{{ $t('index.rules[1]') }}</p>
      <p>{{ $t('index.rules[2]') }}</p>
      <p>{{ $t('index.rules[3]') }}</p>
      <p>{{ $t('index.rules[4]') }}</p>
      <p>{{ $t('index.rules[5]') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import { mapState, mapGetters, mapActions } from 'vuex'
import Clipboard from 'clipboard'
export default {
  name: 'rules',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      myDetail: state => state.myDetail,
      isResonanceClosed: state => state.isResonanceClosed,
      link: () => {
        return document.location.origin + '/#/offer' + '?uid=' + store.state.account
      }
    })
  },
  methods: {
  },
  mounted() {
    const self = this
    const clipboard = new Clipboard('.copy-button')
    clipboard.on('success', function(e) {
      self.$alert(`已经成功复制您的邀请地址: ${self.link}`, '提示', {
        confirmButtonText: '确定',
      })
        e.clearSelection()
    })
    clipboard.on('error', function(e) {
      console.log(e)
    })
  }
}
</script>
<style lang='scss' scoped>
@import "../assets/variables.scss";

.rules {
  display: flex;
  justify-content: center;
  .rules-content {
    width: 58rem;
    height: 51rem;
    background-image: url('~@/assets/image/rule_bg.png');
    background-repeat: no-repeat;
    background-size: 58rem 51rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .rules-container {
      width: 86%;
      height: 86%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p {
        font-size: 16px;
        text-align: left;
      }
    }
    @media screen and (max-width: 560px){
      width: 80vw;
      height: 128.8vw;
      background-size: cover;
      .rules-container {
        p {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
